(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luxisy-commerce-header"] && !Shopify.designMode) return;
  try {
    
  const commerceHeader = document.querySelector('.lxc-header');
  if (commerceHeader && typeof ResizeObserver === 'function') {
    new ResizeObserver(() => {
      document.body.style.setProperty('--header-height', `${commerceHeader.offsetHeight}px`);
      document.body.style.setProperty('--header-group-height', `${document.querySelector('#header-group')?.offsetHeight || commerceHeader.offsetHeight}px`);
    }).observe(commerceHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
